import { TagIcon, EyeIcon, CheckCircleIcon } from "@heroicons/react/24/solid";
import { Message, Conversation } from "./dmTypes";
import { formatDate } from "../../utils/formatDate";

const DMPreview = ({
  conversation,
  selectConversation,
  togglePinned,
  isSelected,
  currentSocial,
}: {
  conversation: Conversation;
  selectConversation: (platformConvoID: string) => void;
  togglePinned: (platformConvoID: string, pinned: boolean) => void;
  isSelected: boolean;
  currentSocial: any;
}) => {
  const lastMessage =
    conversation.messages && conversation.messages.length > 0
      ? conversation.messages[conversation.messages.length - 1]
      : null;

  // ${conversation.pinned ? `bg-yellow bg-opacity-10` : ``}
  return (
    <div
      className={`p-2 flex flex-row hover:bg-white hover:bg-opacity-5 items-center
        ${conversation.status != "0" ? `opacity-65` : ``}
        ${isSelected ? `bg-violet bg-opacity-30` : ``}`}
      onClick={() => selectConversation(conversation.platformConvoID)}
    >
      <div className="w-6 h-6 flex shrink-0">
        {getStatusIcon(conversation.status)}
      </div>
      <div className="relative shrink-0">
        <img
          src={
            conversation.profilePicture ||
            "https://superpower-alpha.s3.amazonaws.com/default_images/no_pfp.jpg"
          }
          className="w-10 h-10 rounded-full object-cover"
        />
        {conversation.pinned && (
          <div className="absolute top-0 right-0 p-1">
            <TagIcon className="w-4 h-4 text-yellow" />
          </div>
        )}
        <div
          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 rounded-full cursor-pointer"
          onClick={(e) => {
            e.stopPropagation(); // Prevent the conversation from being triggered
            togglePinned(conversation.platformConvoID, conversation.pinned);
          }}
        >
          <TagIcon
            className={`w-5 h-5 ${
              conversation.pinned ? "text-yellow" : "text-white"
            }`}
          />
        </div>
      </div>

      <div className="flex flex-col ml-2 min-w-0 flex-1 mr-4">
        <div className="truncate">{conversation.username}</div>
        <div className="truncate text-sm">
          {lastMessage
            ? lastMessage.sender === currentSocial.providerName
              ? "Sent"
              : lastMessage.message || "No message content"
            : "No messages"}
        </div>
      </div>
      <div className="text-xs text-gray-500 whitespace-nowrap shrink-0 text-right mr-1">
        {formatDate(conversation.lastMessageUpdated)}
      </div>
    </div>
  );
};

const getStatusIcon = (status: any) => {
  switch (status) {
    case "0":
      return <div className="bg-violet w-2 h-2 rounded-full m-auto" />;
    case "1":
      return;
    case "2":
      return <CheckCircleIcon className="text-green-400 w-5 h-5" />;
    default:
      return null; // Handle any unexpected status values
  }
};

export default DMPreview;
